import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarMedia from './SnackbarMedia';
import SnackbarContent from './SnackbarContent';
import SnackbarActionText from './SnackbarActionText';
import SnackbarTitle from './SnackbarTitle';
import SnackbarAction from './SnackbarAction';
import SnackbarSpinner from './SnackbarSpinner';

export default function SnackbarProviderConnectionSynchronize({ icon, message }) {
    const { t } = useTranslation('providers');

    return (
        <SnackbarCard>
            <SnackbarLayout>
                <SnackbarMedia>
                    <img src={icon} alt="" />
                </SnackbarMedia>
                <SnackbarContent>
                    <SnackbarActionText>{t('syncing')}</SnackbarActionText>
                    <SnackbarTitle>{message}</SnackbarTitle>
                </SnackbarContent>
                <SnackbarAction>
                    <SnackbarSpinner />
                </SnackbarAction>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarProviderConnectionSynchronize.propTypes = {
    icon: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};
